export const TxClientMode = {
    gRpc: 'grpc',
    rest: 'rest',
};
